(() => {
	document.addEventListener("DOMContentLoaded", () => {

		const klaviyoVendorScripts = [
			"https://a.klaviyo.com/media/js/onsite/onsite.js"
		];

		const klaviyoSettingScripts = [
			klaviyoSettings,
		];

		const chatArminScript = [
			"https://widget.chatarmin.com/widget.js?user=6571c4775ed9ef074a1a3b39"
		];

		let klaviyoScriptsAdded = false;
		let chatArminScriptAdded = false;

		const addScriptTagsToHeader = (scripts, callback) => {
			const scriptPromises = scripts.map((scriptPath) => {
				return new Promise((resolve, reject) => {
					const script = document.createElement("script");
					script.src = scriptPath;
					script.onload = resolve;
					script.onerror = reject;
					document.head.appendChild(script);
				});
			});

			Promise.all(scriptPromises)
				.then(callback)
				.catch(error => console.error("Error loading script:", error));
		};

		const addKlaviyoScripts = () => {
			if (!klaviyoScriptsAdded) {
				addScriptTagsToHeader(klaviyoVendorScripts, () => {
					addScriptTagsToHeader(klaviyoSettingScripts, () => {
						klaviyoScriptsAdded = true;
					});
				});
			}
		};

		const addChatArminScript = () => {
			if (!chatArminScriptAdded) {
				addScriptTagsToHeader(chatArminScript, () => {
					chatArminScriptAdded = true;
				});
			}
		};

		const addScriptsOnce = () => {
			addKlaviyoScripts();
			if (window.location.pathname === '/' || window.location.pathname === '/collections/') {
				addChatArminScript();
			}
			
			window.removeEventListener("click", addScriptsOnce);
			window.removeEventListener("mousemove", addScriptsOnce);
			window.removeEventListener("scroll", addScriptsOnce);
			window.removeEventListener("touchstart", addScriptsOnce);
		};

		window.addEventListener("click", addScriptsOnce);
		window.addEventListener("mousemove", addScriptsOnce);
		window.addEventListener("scroll", addScriptsOnce);
		window.addEventListener("touchstart", addScriptsOnce);
	});
})();
